import React from "react"
import { CenteredLoadingIndicator } from "../molecules/Molecules"
import { FleLayout } from "./FleLayout"

export function FleLoading(): JSX.Element {
  return (
    <FleLayout>
      <CenteredLoadingIndicator style={{ padding: "150px 0" }} />
    </FleLayout>
  )
}
